import { Range, Mark } from 'slate';
export default function makeAddMarkOnTableSelection(store) {
  return {
    toggleMarkOnTableSelection: function toggleMarkOnTableSelection(editor, rawMark, next) {
      var mark = Mark.create(rawMark);
      var selectedCells = editor.getSelectedTableCells();
      if (selectedCells.isEmpty()) return next();
      var activeMarks = editor.getCellsActiveMarks(selectedCells);
      var shouldUnsetMark = activeMarks.has(mark);
      return editor.withoutNormalizing(function () {
        selectedCells.forEach(function (cell) {
          var range = Range.create().moveToRangeOfNode(cell);

          if (shouldUnsetMark) {
            editor.removeMarkAtRange(range, mark);
          } else {
            editor.addMarkAtRange(range, mark);
          }
        });
      });
    }
  };
}